if (!customElements.get('tea-guide-directory')) {
  customElements.define('tea-guide-directory', class extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('[data-directory-group]'));
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.applyViewport = () => {
        this.groups.forEach((group, index) => { group.open = this.desktop.matches || index === 0; });
      };
      this.jump = (event) => {
        const link = event.target.closest('[data-directory-jump]');
        if (!link || !this.contains(link)) return;
        const group = document.getElementById(link.hash.slice(1));
        if (group && this.contains(group)) group.open = true;
      };
      this.selectBlock = (event) => {
        const group = event.target.closest('[data-directory-group]');
        if (group && this.contains(group)) group.open = true;
      };
      this.openHash = () => {
        const id = window.location.hash.slice(1);
        if (!id) return;
        const group = document.getElementById(id);
        if (group && this.groups.includes(group)) group.open = true;
      };
      this.applyViewport();
      this.openHash();
      this.desktop.addEventListener('change', this.applyViewport);
      this.addEventListener('click', this.jump);
      this.addEventListener('shopify:block:select', this.selectBlock);
      window.addEventListener('hashchange', this.openHash);
    }
    disconnectedCallback() {
      this.desktop.removeEventListener('change', this.applyViewport);
      this.removeEventListener('click', this.jump);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      window.removeEventListener('hashchange', this.openHash);
    }
  });
}
